import apinode from '../../apinode'

class BlingService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async getProductBySku(sku) {
    const response = await apinode.get(`/bling/produtos/${sku}/${this.idconta}`)

    return response.data
  }

  async importProduct(sku) {
    const response = await apinode.get(
      `/bling/importar/produtos/${sku}/${this.idconta}`,
    )

    return response.data.message
  }
}

export default new BlingService()
